import React, { useState } from 'react';
import { Typography, Button, FormControlLabel, OutlinedInput } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import { ReactComponent as CallToActionIcon } from '../../../../../assets/images/left_click.svg';

type CallToActionItemProps = {
	item: any;
	handleUpdateFooterItem: (_id: any, _key: string, _value: any) => void;
	handleDeleteFooterItem: (_id: any) => void;
};
const CallToActionItem = ({ item, handleUpdateFooterItem, handleDeleteFooterItem }: CallToActionItemProps) => {
	const { id, headline, description, link } = item;
	const [isExpand, setIsExpand] = useState(false);

	return (
		<>
			<div
				style={{
					border: '1px solid #909CA5',
					borderTopLeftRadius: 4,
					borderTopRightRadius: 4,
					borderBottomLeftRadius: isExpand ? 0 : 4,
					borderBottomRightRadius: isExpand ? 0 : 4,
					cursor: 'pointer',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'space-between',
				}}
				onClick={() => {
					setIsExpand(!isExpand);
				}}
			>
				<div
					style={{
						display: 'flex',
						justifyContent: 'start',
						alignItems: 'center',
						gap: 10,
						padding: '14px 0 14px 10px',
					}}
				>
					<CallToActionIcon />
					<Typography variant="body1">{'Call to action'}</Typography>
				</div>
				<div style={{ display: 'flex' }}>
					<Button
						style={{ minWidth: 0, padding: '14px 10px', borderRadius: 0, borderLeft: '1px solid #909CA5' }}
						onClick={(e) => {
							e.stopPropagation();
							e.preventDefault();
							handleDeleteFooterItem(id);
						}}
					>
						<CloseIcon fontSize="small" />
					</Button>
				</div>
			</div>
			{isExpand && (
				<div
					style={{
						borderLeft: '1px solid #909CA5',
						borderRight: '1px solid #909CA5',
						borderBottom: '1px solid #909CA5',
						borderTopLeftRadius: 0,
						borderTopRightRadius: 0,
						borderBottomLeftRadius: 4,
						borderBottomRightRadius: 4,
						padding: '14px 10px',
					}}
				>
					<FormControlLabel
						className={'inspect-media__input--full'}
						style={{ display: 'flex' }}
						control={
							<OutlinedInput
								value={headline}
								fullWidth
								onChange={(event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
									handleUpdateFooterItem(id, 'headline', event.target.value);
								}}
								placeholder="Add text"
							/>
						}
						label={
							<span className={'inspect-media__input-label'}>
								<Typography variant="body1">Headline</Typography>
							</span>
						}
						labelPlacement={'top'}
					/>
					<FormControlLabel
						className={'inspect-media__input--full'}
						style={{ display: 'flex' }}
						control={
							<OutlinedInput
								value={description}
								fullWidth
								onChange={(event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
									handleUpdateFooterItem(id, 'description', event.target.value);
								}}
								multiline
								rows={3}
								maxRows={5}
								placeholder="Add text"
							/>
						}
						label={
							<span className={'inspect-media__input-label'}>
								<Typography variant="body1">Description</Typography>
							</span>
						}
						labelPlacement={'top'}
					/>
					<FormControlLabel
						className={'inspect-media__input--full'}
						style={{ display: 'flex' }}
						control={
							<OutlinedInput
								value={link}
								fullWidth
								onChange={(event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
									handleUpdateFooterItem(id, 'link', event.target.value);
								}}
								placeholder="Add URL"
							/>
						}
						label={
							<span className={'inspect-media__input-label'}>
								<Typography variant="body1">Link</Typography>
							</span>
						}
						labelPlacement={'start'}
					/>
				</div>
			)}
		</>
	);
};

export default CallToActionItem;
